import Seo, { SITE_URL } from "@/components/feature/Seo";
import SiteLayout from "@/components/feature/SiteLayout";
import { articles, faqs, siteInfo } from "@/mocks/gossipData";
import HomeHero from "./components/HomeHero";
import HomeHot from "./components/HomeHot";
import HomeExplore from "./components/HomeExplore";
import HomeFaq from "./components/HomeFaq";
import HomeCta from "./components/HomeCta";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    url: SITE_URL,
    description: siteInfo.intro,
    email: siteInfo.email,
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.name,
    url: SITE_URL,
    description: siteInfo.tagline,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/gossip?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "今日热瓜精选合集",
    itemListElement: articles.slice(0, 6).map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      url: `${SITE_URL}/gossip/${item.id}`,
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="瓜田福利社｜福利吃瓜大合集与精选盘点汇总版"
        description="瓜田福利社整理福利吃瓜大合集、资源包盘点、精选内容与汇总版，涵盖娱乐圈、影视综艺、网络热议、时尚生活、音乐现场与体育竞技，每日更新，一站看全。"
        keywords="福利吃瓜,福利吃瓜大合集,福利吃瓜资源包,福利吃瓜精选,福利吃瓜盘点,福利吃瓜汇总版"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteLayout>
        <HomeHero />
        <HomeHot />
        <HomeExplore />
        <HomeFaq />
        <HomeCta />
      </SiteLayout>
    </>
  );
}